var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTele2 = function SvgTele2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF3495",
    d: "M4.0395 7.95215H0.80188V11.1483H4.0395V7.95215Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M13.4008 16.6607H22.1962V19.8568H13.4008V16.6607ZM17.3653 9.36605C18.3632 9.36605 19.1715 10.164 19.1715 11.149C19.1715 12.1341 18.3632 12.932 17.3653 12.932H13.4008V16.1281H17.3653C19.5102 16.1281 21.347 14.7997 22.0745 12.932C22.2909 12.378 22.4091 11.777 22.4091 11.149C22.4091 8.40371 20.1466 6.16992 17.3653 6.16992C14.584 6.16992 12.3215 8.40339 12.3215 11.149H15.5591C15.5591 10.164 16.3675 9.36605 17.3653 9.36605Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M7.81749 16.6607H12.8612V19.8569H9.62361C6.83821 19.8569 4.57983 17.6275 4.57983 14.8778V4.14258H7.81749V7.95302H11.5948V11.1491H7.81749V16.6607Z"
  })));
};
export default SvgTele2;